import { ReactComponent as A } from '../../weatherIcons/01d.svg';
import { ReactComponent as B } from '../../weatherIcons/02d.svg';
import { ReactComponent as C } from '../../weatherIcons/03d.svg';
import { ReactComponent as D } from '../../weatherIcons/04d.svg';
import { ReactComponent as E } from '../../weatherIcons/09d.svg';
import { ReactComponent as F } from '../../weatherIcons/10d.svg';
import { ReactComponent as G } from '../../weatherIcons/11d.svg';
import { ReactComponent as H } from '../../weatherIcons/13d.svg';
import { ReactComponent as I } from '../../weatherIcons/50d.svg';

import { ReactComponent as J } from '../../weatherIcons/01n.svg';
import { ReactComponent as K } from '../../weatherIcons/02n.svg';
import { ReactComponent as L } from '../../weatherIcons/10n.svg';

import { ReactComponent as PFC } from "../../customIcons/PFC.svg";


import {useEffect, useState} from "react";

const WeatherIcons = ({ selectedWeather, size, sizeFull }) => {

    const [SelectedComponent, setSelectedComponent] = useState(null); // This will store the component itself
    const sharedClassName = `transition-all duration-500 animate-epicReveal size-${size} ${sizeFull}`; // You can also move this to Tailwind config if reused widely


    useEffect(() => {

        const volumeMap = {
            "01d": { component: A },
            "02d": { component: B },
            "03d": { component: C },
            "04d": { component: D },
            "09d": { component: E },
            "10d": { component: F },
            "11d": { component: G },
            "13d": { component: H },
            "50d": { component: I },
            
            "01n": { component: J },
            "02n": { component: K },
            "03n": { component: C },
            "04n": { component: D },
            "09n": { component: E },
            "10n": { component: L },
            "11n": { component: G },
            "13n": { component: H },
            "50n": { component: I },
        };

        const volumeData = volumeMap[selectedWeather];

        if (volumeData) {
            setSelectedComponent(volumeData.component);
        } else {
            setSelectedComponent(PFC);
        }

    }, [selectedWeather]);


    return (
        <div className={`w-fit h-fit`}>

            {SelectedComponent ? (
                <SelectedComponent className={sharedClassName} />
            ) : (
                <PFC className={sharedClassName} />
            )}


        </div>
    )
}

export default WeatherIcons;
